/* eslint-disable */
import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { SharedRoutes } from '@pgaoc/shared-lib';
import { InternalAuthRepository } from '../repository/internal-auth-repository';

type Activation = Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree;

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private internalAuthRepository = inject(InternalAuthRepository);
  private router = inject(Router);

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Activation {
    return this.internalAuthRepository.isAuthenticated().pipe(
      take(1),
      map(authenticatedUser => {
        return !!authenticatedUser || this.router.createUrlTree([SharedRoutes.auth()]);
      }),
    );
  }
}
